var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"main-con"},[_c('navcon'),_vm._v(" "),_c('div',{staticClass:"cbody"},[_c('transition',{attrs:{"name":!_vm.isMobile && _vm.transitionName}},[_c('router-view',{attrs:{"no-swipe":_vm.isMobile}})],1)],1),_vm._v(" "),_c('foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355e3c93","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 